// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_0YxFj"};